import { PageHeader } from "@/components/layout/PageHeader";
import { VenueList } from "@/components/venues/VenueList";
import { CreateVenueDialog } from "@/components/venues/CreateVenueDialog";
import { useVenues } from "@/hooks/useVenues";

export default function VenuesPage() {
  const { data: venues = [], isLoading, error } = useVenues();

  return (
    <div>
      <PageHeader title="Lokalizacje" action={<CreateVenueDialog />} />
      {isLoading && (
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-14 rounded-lg bg-slate-100 animate-pulse" />
          ))}
        </div>
      )}
      {error && <p className="text-destructive">Błąd ładowania: {error.message}</p>}
      {!isLoading && !error && <VenueList venues={venues} />}
    </div>
  );
}
